export default {"src":"/_next/static/media/star-brown.fb799bd7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};